import { createSelector } from 'reselect';

const selectCargoQuotes = (state: any) => state.cargoQuotes;

export const selectCargoQuotesCurrentItem = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.current);

export const selectCargoQuotesListItems = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.list);

export const selectCargoQuotesItemById = (itemId: any) =>
    createSelector(selectCargoQuotesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCargoQuotesQueryItems = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.query);

export const selectCargoQuotesCreatedItem = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.create);

export const selectCargoQuotesUpdatedItem = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.update);

export const selectCargoQuotesReadItem = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.read);

export const selectCargoQuotesDeletedItem = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.delete);

export const selectCargoQuotesSearchedItems = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.search);

export const selectCargoQuotesItemsCount = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.count);

export const selectCargoQuotesItemsFilter = createSelector([selectCargoQuotes], (cargoQuotes) => cargoQuotes.filter);